import _ from 'lodash';
export var incentivesPerLineItem = function incentivesPerLineItem(paymentIncentives) {
  return _.map(paymentIncentives, function (incentive) {
    var _incentive$discountNa;
    return {
      type: (_incentive$discountNa = incentive.discountName) !== null && _incentive$discountNa !== void 0 ? _incentive$discountNa : incentive.name,
      value: Number(incentive.amount) / 100
    };
  });
};

/**
 * IncentivesPerLineItem is an array of objects that represent the incentives rewarded for each line item.
 * The object has the following structure:
 * {
 * type: "Pay By Bank Incentive",
 * value: 1.00
 * },
 * {
 * type: "Pay By Bank Incentive",
 * value: 2.60
 * }
 *
 * Consolidate the incentives by type and sum the values.
 * {
 * type: "Pay By Bank Incentive",
 * value: 3.60
 * }
 */
export var consolidateIncentives = function consolidateIncentives(incentives) {
  return _.map(_.groupBy(incentives, 'type'), function (incentives, type) {
    return {
      type: type,
      value: _.sumBy(incentives, 'value')
    };
  });
};